import { render } from "./AppointmentsByMonth.vue?vue&type=template&id=30ac6c53"
import script from "./AppointmentsByMonth.vue?vue&type=script&lang=js"
export * from "./AppointmentsByMonth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__